export default "__VITE_ASSET__c9e680cf__"